import React from "react";
import ReportMetricsListingForAlert from "./ReportMetricsListingForAlert";


const ManageAlert = (props) => {
  const { data, modalControls } = props;
  const onActionTrigger = () => modalControls.hideModal();

  return (
    <ReportMetricsListingForAlert {...data} onActionTrigger={onActionTrigger} />
  );
}

export default ManageAlert;
